import styled from "styled-components";

export const InputWrapper = styled.div`
  position: relative;
  .input-icon {
    color: #9e9e9e;
    position: absolute;
    right: 10px;
    top: 15px;
    background: transparent;
    border: none;
    cursor: pointer;
    padding: 0;

    &:focus {
      outline: 2px solid #26a69a;
      outline-offset: 2px;
      border-radius: 2px;
    }

    &:hover {
      color: #757575;
    }
  }
`;